import $ from 'jquery';

if ( $( '.components-table').length ) {

  // Components table filtering by selects and input
  $(document).on('change keyup', '.components-table-filter', function ( e ) {

    var $input = $( this );
    var tag = $input.prop('tagName').toLowerCase();

    if ( tag === 'select' ) {
      // For selects we update the previous label

      var $label = $input.prev();
      var label = $( 'option:selected', $input ).text();

      $label.html( label );

    }

    filterComponentTableByValues();

  });

  filterComponentTableByValues();

  function filterComponentTableByValues() {
    // Filter visible component table rows by filter values

    $( '.component-table-row' ).hide();

    var totalSearch = '';
    var $pdfLink = $( '.pdf-download-btn' );
    var pdfOptions = {
      lang: 'en',
      pages: []
    };
    var $pdfButton = $( 'button.pdf' );

    if ( $pdfLink.length ) {
      // Bring the download PDF -button back

      $pdfLink.remove();

      $pdfButton.html( 'Download all <span class="count"></span> PDFs' )
        .css( 'width', 'auto' )
        .show();

    }

    $( '.components-table-filter' ).each( function ( i, filter ) {

      var $filter = $( filter );
      var filterKey = $filter.data( 'filterColumn' );
      var filterValue = $.trim( $filter.val() );

      totalSearch += filterValue;

      if ( filterValue !== '' ) {

        $( '.component-table-row' ).each( function ( i, row ) {

          var $row = $( row );
          var $rowCell = $('[data-cell="' + filterKey + '"]', $row);
          var cellText = $rowCell.text().toLowerCase();
          var hasFilterValue = cellText.indexOf( filterValue.toLowerCase() ) !== -1;

          if ( hasFilterValue ) {

            $row.show();

          }

        });

      }

    });

    if ( totalSearch === '' ) {

      $( '.component-table-row' ).show();

    }

    $( '.component-table-row:visible' ).each( function ( i, row ) {
      // Update pdf download button with component parameters

      var $row = $( row );
      var data = $row.data();

      pdfOptions.pages.push({
        page: 'cm-page://' + data.pageId + '/',
        params: {
          component: data.pageUrlname
        }
      });

    });

    if ( pdfOptions.pages.length ) {

      $pdfButton.data( 'options', encodeURIComponent( JSON.stringify( pdfOptions ) ) )
        .find( '.count' ).html( pdfOptions.pages.length );

      $pdfButton.show();

    } else {
      // Hide PDF button if no components visible

      $pdfButton.hide();

    }

  }
  /* eslint-enable */

  $( '.component-table-row' ).each( function ( i, row ) {
    // Disable links if row isn't expanded

    var $row = $( row );
    var $link = $( '[data-cell="name"] a', $row );

    $link.on( 'click', function ( e ) {

      if ( !$row.hasClass( 'expanded' ) ) {

        e.preventDefault();

      }
    });
  });

  $( '.components-table .toggle' ).on( 'click', function ( e ) {

    e.preventDefault();
    e.stopPropagation();

    var $toggle = $( this );
    var $row = $toggle.parent();

    $row.toggleClass( 'expanded' );

  });
}
